import HeaderCMS from "@/components/navigation/HeaderCMS.tsx";
import { useAuth } from "@/context/auth/AuthContext";
import React from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router-dom";

interface PrivateRouteProps {
  children: React.ReactNode;
}

export const PrivateRouteCMS = ({ children }: PrivateRouteProps) => {
  const { t } = useTranslation();
  const { checkInstanceAndToken, instanceData, boPreferencesReady } = useAuth();
  const location = useLocation();

  const haveCMSId = instanceData?.CMS?.id;

  if (!checkInstanceAndToken()) {
    return <Navigate to="/login" />;
  }

  if (!boPreferencesReady) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent" />
      </div>
    );
  }

  // Mode ADVANCED verrouille hors ancien CMS (pas sur les routes /cms/advanced/*).
  if (
    instanceData?.CMS?.cmsAccessMode === "ADVANCED" &&
    !location.pathname.startsWith("/cms/advanced")
  ) {
    return <Navigate to="/cms/advanced/accueil" replace />;
  }

  return (
    <div>
      <HeaderCMS />
      {haveCMSId && children}
      {!haveCMSId && (
        <div className="flex flex-col items-center justify-center h-screen">
          <p className="text-2xl font-bold">{t("titleNoCMSIdCreated")}</p>
          <p className="text-sm">{t("descriptionNoCMSIdCreated")}</p>
        </div>
      )}
    </div>
  );
};
